/**
 * The media library's client — search, rename, hide and replace.
 *
 * `replace` is the interesting one: it writes new bytes over the same URL, so
 * every page already showing that picture updates without being re-linked.
 */
import api, { getErrorMessage } from '@/lib/api';

export const searchLibrary = async (params = {}) => {
  const { data } = await api.get('/media/library', { params });
  return data;
};

export const libraryFacets = async () => {
  const { data } = await api.get('/media/library/facets');
  return data;
};

export const renameAsset = async (id, name) => {
  const { data } = await api.patch(`/media/library/${id}`, { name });
  return data;
};

export const hideAsset = async (id, hidden = true) => {
  const { data } = await api.post(`/media/library/${id}/hide`, null, { params: { hidden } });
  return data;
};

export const replaceAsset = async (id, file, onProgress) => {
  const form = new FormData();
  form.append('file', file);
  try {
    const { data } = await api.post(`/media/library/${id}/replace`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
      },
    });
    return data;
  } catch (err) {
    throw new Error(getErrorMessage(err, 'That file could not replace this one'));
  }
};

export const prettySize = (bytes) => {
  const n = Number(bytes || 0);
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};
